import { render, staticRenderFns } from "./DigitalOdontogram.vue?vue&type=template&id=60e883b4&scoped=true"
import script from "./DigitalOdontogram.vue?vue&type=script&lang=js"
export * from "./DigitalOdontogram.vue?vue&type=script&lang=js"
import style0 from "./DigitalOdontogram.vue?vue&type=style&index=0&id=60e883b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e883b4",
  null
  
)

export default component.exports